document.addEventListener('DOMContentLoaded', () => {
 
  const headers = document.querySelectorAll('[class*="section-sections--"]');
  const gradient = document.querySelector('.utility-bar.gradient');

  if (!headers.length || !gradient) return; 

 

  headers.forEach(header => {
    const observer = new MutationObserver(() => {
      if (header.classList.contains('open')) {
      
         gradient.style.setProperty('display', 'none', 'important');
         gradient.style.backgroundColor = 'transparent';
      } else {
        
         gradient.style.setProperty('display', '');
        gradient.style.backgroundColor = originalBgColor;
      }
    });

    observer.observe(header, { attributes: true, attributeFilter: ['class'] });
  });
});
